var _rect, _circle, _path, _circle2, _path2, _circle3, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#EB5E27"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.7812,
    cy: 17.6875,
    r: 3.75,
    stroke: "#F5F5F5",
    strokeWidth: 1.875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4383 19.5625C33.5699 19.1227 33.6414 18.6493 33.6414 18.1562C33.6414 17.6632 33.5699 17.1898 33.4383 16.75H41.5625C42.3391 16.75 42.9688 17.3796 42.9688 18.1562C42.9688 18.9329 42.3391 19.5625 41.5625 19.5625H33.4383ZM26.7051 19.5625H13.4375C12.6609 19.5625 12.0312 18.9329 12.0312 18.1562C12.0312 17.3796 12.6608 16.75 13.4375 16.75H26.7051C26.5736 17.1898 26.502 17.6632 26.502 18.1562C26.502 18.6493 26.5736 19.1227 26.7051 19.5625Z",
    fill: "#F5F5F5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.6875,
    cy: 4.6875,
    r: 3.75,
    transform: "matrix(-1 0 0 1 28.9062 23.3125)",
    stroke: "#F5F5F5",
    strokeWidth: 1.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5617 29.875C21.4301 29.4352 21.3586 28.9618 21.3586 28.4688C21.3586 27.9757 21.4301 27.5023 21.5617 27.0625H13.4375C12.6609 27.0625 12.0312 27.6921 12.0312 28.4688C12.0312 29.2454 12.6609 29.875 13.4375 29.875H21.5617ZM28.2949 29.875H41.5625C42.3391 29.875 42.9688 29.2454 42.9688 28.4688C42.9688 27.6921 42.3392 27.0625 41.5625 27.0625H28.2949C28.4264 27.5023 28.498 27.9757 28.498 28.4688C28.498 28.9618 28.4264 29.4352 28.2949 29.875Z",
    fill: "#F5F5F5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.7812,
    cy: 38.3125,
    r: 3.75,
    stroke: "#F5F5F5",
    strokeWidth: 1.875
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4383 40.1875C33.5699 39.7477 33.6414 39.2743 33.6414 38.7812C33.6414 38.2882 33.5699 37.8148 33.4383 37.375H41.5625C42.3391 37.375 42.9688 38.0046 42.9688 38.7812C42.9688 39.5579 42.3391 40.1875 41.5625 40.1875H33.4383ZM26.7051 40.1875H13.4375C12.6609 40.1875 12.0312 39.5579 12.0312 38.7812C12.0312 38.0046 12.6608 37.375 13.4375 37.375H26.7051C26.5736 37.8148 26.502 38.2882 26.502 38.7812C26.502 39.2743 26.5736 39.7477 26.7051 40.1875Z",
    fill: "#F5F5F5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.fe0aaa8f21b71b7330ba3d1daf92b3ff.svg";
export { ForwardRef as ReactComponent };